import { render } from "./PdtList.vue?vue&type=template&id=b7c083e6&scoped=true"
import script from "./PdtList.vue?vue&type=script&lang=js"
export * from "./PdtList.vue?vue&type=script&lang=js"

import "./PdtList.vue?vue&type=style&index=0&id=b7c083e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7c083e6"]])

export default __exports__